var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v2-page"},[_c('V2Circle'),_c('div',{staticClass:"js-hero-wrap"},[_c('V2Hero'),_c('V2Stripes')],1),_c('V2Skills'),_c('V2Projects'),_c('AppCursor')],1)}
var staticRenderFns = []

export { render, staticRenderFns }